<template lang="pug">
    .backgroundline(:data-kind='kind')
</template>

<script>
export default {
    name: 'BackgroundLine',

    props: {
        kind: {
            type: Number,
            required: true
        }
    }
};
</script>

<style lang="scss">
@import '~poly-fluid-sizing';
@import '../assets/css/vars.scss';

.backgroundline {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.7;

    @supports (mix-blend-mode: color-dodge) {
        display: block;
    }

    &[data-kind='1'] {
        background: url('../assets/img/lines/1.jpg') no-repeat 50% 50% / cover;
    }

    &[data-kind='2'] {
        background: url('../assets/img/lines/2.jpg') no-repeat 50% 50% / cover;
    }
}
</style>
